<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHost_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-10c1.655 0 3-1.346 3-3 0-1.655-1.346-3-3-3S9 7.345 9 9s1.346 3 3 3m4.546 2.722c-.781-.835-2.253-1.455-4.903-1.455-2.672 0-4.146.631-4.922 1.477l-.02.022c-.21.228-.55.597-.691 1.506-.077.49.31.937.807.937h9.653a.817.817 0 0 0 .807-.937c-.144-.92-.492-1.293-.717-1.535z"
        clip-rule="evenodd"
    />
</svg>
